import moment from "moment";
import { useEffect, useState } from "react";

const useCompany = ({ user }) => {
    const [companyLogo, setCompanyLogo] = useState("");
    const [daysToGo, setDaysToGo] = useState(0);
    const [daysLeft, setDaysLeft] = useState(0);

    let launchDate = user?.launchDate;
    let logo = user?.logo;
    let id = user?.id;
    let name = user?.name;

    useEffect(() => {

        let days = 30;
        let dayBeforeBegin = 0;

        let current = moment(new Date());
        launchDate = new Date(launchDate);
        launchDate.setHours(0, 0, 0);
        launchDate = moment(launchDate);

        dayBeforeBegin = launchDate.diff(current, 'days');

        if (dayBeforeBegin <= 0) {
            let daysLeft = current.diff(launchDate, 'days');
            days = days - daysLeft;
        }

        days = days < 0 ? 0 : days;

        setDaysToGo(dayBeforeBegin);
        setDaysLeft(days);

        const bannerLogo = (process.env.REACT_APP_ENVIRONMENT == "PROD" ? process.env.REACT_APP_BASE_API_URL : process.env.REACT_APP_BASE_API_URL_DEV) + logo;
        setCompanyLogo(bannerLogo);

    }, [id]);

    return {
        companyLogo: companyLogo,
        daysToGo: daysToGo,
        daysLeft: daysLeft,
        companyName: name,
        launchDate: launchDate,
    };
}

export default useCompany;
